export enum SystemType {
    WEB = 'web',
    MOB = 'mobile',
}

export enum ActionType {
    READ = '00',
    CREATE = '01',
    UPDATE = '02',
    DELETE = '03',
    REVIEW = '04',
    UPLOAD = '05',
    DOWNLOAD = '06',
}

export interface LoginAttempt {
    remainingCount: number;
    unlockTime: string;
}

export interface Credential {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
}

export interface Menu {
    id: string;
    name: string;
    programName: string;
    iconName?: string;
    position: number;
    children?: Menu[];
}

export interface UserInterface {
    nickname: string;

    actions: string[];
    menus: Menu[];
}

export interface AuthRepository {
    getSystemType(): SystemType;
    setSystemType(value?: SystemType): void;

    getAccount(): Promise<string>;
    setAccount(value?: string): Promise<void>;

    getAccessToken(): Promise<string>;
    getRefreshToken(): Promise<string>;
    getCredential(): string;
    setCredential(value?: Credential): Promise<void>;

    login(account: string, password: string): Promise<Credential> | never;
    logout(): Promise<void> | never;
    refreshToken(): Promise<Credential> | never;
    changePassword(
        old_password: string,
        new_password: string
    ): Promise<void> | never;
    getUserInterface(): Promise<UserInterface> | never;
}

export interface AuthService {
    getSystemType(): SystemType;
    setSystemType(value: SystemType): void;

    getAccount(): Promise<string>;
    rememberAccount(value: string): void;
    clearRememberedAccount(): void;

    getLoginState(): boolean;
    setCredential(value: Credential): void;
    clearCredential(): void;

    login(account: string, password: string): Promise<void>;
    logout(): Promise<void>;
    refreshToken(): Promise<void>;
    changePassword(old_password: string, new_password: string): Promise<void>;
    getUserInterface(): Promise<UserInterface>;
}
